import React, { useEffect } from 'react';
import type { SingleCommonType } from '../../types';
import { commonBackInfo } from '../../utils';
import { commentsPlaceholder } from '../../constants/placeholder';
import CustomFollowerRange from '../../components/CustomFollowerRange';
import { useSetRangeDefaultValue, dealwithRangeDataWithNewFormat } from '../../hooks/init';
import { useIntl } from 'umi';
import './index.scss';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function CommentsRange({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  lang,
  oriDefaultFilter,
  backOriDefaultValue,
}: SingleCommonType) {
  const { rangeValue, setRangeValue, followerRef, options, diffClassName } =
    useSetRangeDefaultValue({
      defaultValue,
      filterValue,
      defaultKey: 'comments',
      oriDefaultFilter,
      backOriDefaultValue,
      options: [
        { text: 'All', value: '-' },
        { text: '0 ~ 500', value: '0-0.5' },
        { text: '500 ~ 1000', value: '0.5-1' },
        { text: '> 1000', value: '1-' },
      ],
      dealwithDateFunc: dealwithRangeDataWithNewFormat,
    });
  const { formatMessage } = useIntl();
  useEffect(() => {
    const showHeader = followerRef.current?.buttonElement?.(rangeValue);
    const data = [];
    if (rangeValue !== '-') {
      const [start, end] = rangeValue.split('-');
      // 新格式: 使用 start/end
      type DataItem = { start: number; end?: number };
      const dataItem: DataItem = {
        start: Number(start) * 1000,
      };
      if (end !== '') {
        dataItem.end = Number(end) * 1000;
      }
      data.push(dataItem);
    }

    onChange?.(
      'commentsRange',
      commonBackInfo({ comments: data }, { commentsRange: showHeader }),
    );
  }, [rangeValue, formatMessage]);

  return (
    <div className={`dbo-comments-range-wrapper ${diffClassName}`}>
      <CustomFollowerRange
        lang={lang}
        ref={followerRef}
        options={options}
        setRangeValue={setRangeValue}
        rangeValue={rangeValue}
        placeholder={commentsPlaceholder}
        pointKey={FilterButtonPoint.commentsRange}
      ></CustomFollowerRange>
    </div>
  );
}
